import { render, staticRenderFns } from "./JoppdADetail.vue?vue&type=template&id=71a3f478&scoped=true"
import script from "./JoppdADetail.vue?vue&type=script&lang=js"
export * from "./JoppdADetail.vue?vue&type=script&lang=js"
import style0 from "./JoppdADetail.vue?vue&type=style&index=0&id=71a3f478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a3f478",
  null
  
)

export default component.exports